// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/Images/ooc_bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournamentInfosCardContainer {
  width: 100%;
  display: flex;
  justify-content: start;
  padding: 12px 20px;
  flex-direction: column;
  gap: 16px;
}

.tournamentInfosCardContainer p {
  color: #fff;
  font-family: Lato;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 100%; /* 12px */
}

.tournamentInfosCardWraper {
  display: flex;
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  width: 100%;
  padding: 12px 16px;
  border-radius: 12px;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.tournamentInfosCardTop {
  width: 100%;
}

.tournamentInfosCardTop ul {
  width: 100%;
  display: flex;
  list-style: none;
  gap: 16px;
}

.tournamentInfosCardTop ul li {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.tournamentInfosCardLots {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 16px;
  justify-content: center;
  align-items: center;
  gap: 12px;
  border-radius: 6px;
  background: rgba(24, 48, 81, 0.25);
  -webkit-backdrop-filter: blur(15px);
          backdrop-filter: blur(15px);
}

.tournamentInfosCardLots p {
  display: flex;
  flex-direction: column;
}

.tournamentInfosCardSlider {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  gap: 8px;
  padding-bottom: 8px;
}

.tournamentInfosCardWraper button {
  display: flex;
  height: 48px;
  padding: 0px 16px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 39px;
  background: #c3d32c;
  border: none;
  color: #0C0B20;
  font-family: Lato;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 21px */
  letter-spacing: 1.82px;
  transition: all ease-in-out 0.2s;
  cursor: pointer;
}

.tournamentInfosCardWraper button:hover{
  transform: scale(1.02);
}

.tournamentInfosCardSlider p{
  width: 100%;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/components/Tournament/TournamentInfosCard.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;;AAEA;EACE,aAAa;EACb;2CACuC;EACvC,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,sBAAsB;EACtB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB","sourcesContent":[".tournamentInfosCardContainer {\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: start;\r\n  padding: 12px 20px;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n}\r\n\r\n.tournamentInfosCardContainer p {\r\n  color: #fff;\r\n  font-family: Lato;\r\n  font-size: 20px;\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  line-height: 100%; /* 12px */\r\n}\r\n\r\n.tournamentInfosCardWraper {\r\n  display: flex;\r\n  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),\r\n    url(\"../../assets/Images/ooc_bg.png\");\r\n  background-size: cover;\r\n  width: 100%;\r\n  padding: 12px 16px;\r\n  border-radius: 12px;\r\n  justify-content: center;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n.tournamentInfosCardTop {\r\n  width: 100%;\r\n}\r\n\r\n.tournamentInfosCardTop ul {\r\n  width: 100%;\r\n  display: flex;\r\n  list-style: none;\r\n  gap: 16px;\r\n}\r\n\r\n.tournamentInfosCardTop ul li {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n.tournamentInfosCardLots {\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 16px;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 12px;\r\n  border-radius: 6px;\r\n  background: rgba(24, 48, 81, 0.25);\r\n  backdrop-filter: blur(15px);\r\n}\r\n\r\n.tournamentInfosCardLots p {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.tournamentInfosCardSlider {\r\n  display: flex;\r\n  flex-direction: row;\r\n  flex-wrap: nowrap;\r\n  width: 100%;\r\n  max-width: 100%;\r\n  overflow-x: auto;\r\n  gap: 8px;\r\n  padding-bottom: 8px;\r\n}\r\n\r\n.tournamentInfosCardWraper button {\r\n  display: flex;\r\n  height: 48px;\r\n  padding: 0px 16px;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 4px;\r\n  border-radius: 39px;\r\n  background: #c3d32c;\r\n  border: none;\r\n  color: #0C0B20;\r\n  font-family: Lato;\r\n  font-size: 16px;\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  line-height: 150%; /* 21px */\r\n  letter-spacing: 1.82px;\r\n  transition: all ease-in-out 0.2s;\r\n  cursor: pointer;\r\n}\r\n\r\n.tournamentInfosCardWraper button:hover{\r\n  transform: scale(1.02);\r\n}\r\n\r\n.tournamentInfosCardSlider p{\r\n  width: 100%;\r\n  text-align: center;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
